import cn from 'bem-cn';

import { ValidationWrapperProps } from './ValidationWrapper.types';

import './ValidationWrapper.scss';

const b = cn('validation-wrapper');

export const ValidationWrapper = ({ children, error }: ValidationWrapperProps) => {
    return (
        <div className={b({ error: Boolean(error) })} data-error-message={error}>
            {children}
        </div>
    );
};
